<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="false"
    width="720px"
  >
    <div>
      <div class="ft-bold mb5">*1、2、3步必填</div>
      <div class="mb10">
        <p class="mb5">1. 选择报告类型（必选）</p>
        <div>
          <el-popover placement="right" width="800" trigger="hover">
            <div>
              <div>示例：</div>
              <img src="../../assets/images/company_process.png" class="img_max" />
            </div>
            <span slot="reference" class="pointer ft-blue">
              <el-radio v-model="type" label="progress">人选概况（只统计数字，不列出具体人名）</el-radio>
            </span>
          </el-popover>
        </div>
        <div>
          <el-popover placement="right" width="800" trigger="hover">
            <div>
              <div>示例：</div>
              <img src="../../assets/images/company_namelist.png" class="img_max" />
            </div>
            <span slot="reference" class="pointer ft-blue">
              <el-radio v-model="type" label="recomend-namelist">人选详情报告（列出具体人名）</el-radio>
            </span>
          </el-popover>
        </div>
        <div>
          <span slot="reference" class="pointer ft-blue">
            <el-radio v-model="type" label="client-project-count">客户项目盘点</el-radio>
          </span>
        </div>
        <div>
          <span slot="reference" class="pointer ft-blue">
            <el-radio v-model="type" label="commendatory-client-company-count">客户项目盘点(表扬版)</el-radio>
          </span>
        </div>
        <div>
          <span slot="reference" class="pointer ft-blue">
            <el-radio v-model="type" label="client-year-report">年度回顾报告版</el-radio>
          </span>
        </div>
      </div>
      <div class="mb10">
        <p class="mb5">2. 请选择公司（必选）</p>
        <el-select
          v-model="companyName"
          filterable
          reserve-keyword
          remote
          size="mini"
          placeholder="请输入关键词，并选择"
          :remote-method="searchCompany"
          @change="chooseCompany"
        >
          <el-option v-for="(option, index) in companies" :key="index" :value="option.简称" :label="option.简称" />
        </el-select>
        <span v-show="error[0]" class="ml10 ft-danger">请选择公司简称</span>
      </div>
      <div v-show="type !== 'commendatory-client-company-count' && type !== 'client-year-report'" class="mb10">
        <p class="mb5">3. 请选择时间段（不选择将默认项目成立至今）</p>
        <div>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="mini"
            unlink-panels
            value-format="timestamp"
            start-placeholder="起始时间"
            end-placeholder="结束时间"
            range-separator="~"
            :picker-options="pickerOptions"
          />
        </div>
      </div>
      <div v-show="type === 'commendatory-client-company-count'" class="mb10">
        <p class="mb5">3. 请选择时间段（必选）</p>
        <div>
          <el-date-picker v-model="yearDateRange" type="year" size="mini" value-format="timestamp" placeholder="选择年">
          </el-date-picker>
        </div>
      </div>

      <div v-show="type === 'recomend-namelist'" class="mb10">
        <p class="mb5">4. 请选择需要的表头字段，并排序</p>
        <el-checkbox v-model="checkAll" class="pd10-y" :indeterminate="isIndeterminate" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <el-checkbox-group v-model="checked">
          <el-checkbox v-for="(val, index) in checkbox" :key="index" :label="val" class="checkbox_item">
            {{ val }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-show="type === 'recomend-namelist'">
        <p class="mb5">5. 拖拽即可排列表头顺序</p>
        <div id="sortList" class="flex-row flex-wrap">
          <div v-for="(val, i) in checked" :key="i" :index="i" class="mr10 mb10 headers_item">{{ val }}</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" @click="onConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  data() {
    return {
      visible: false,
      companyName: '',
      dateRange: null,
      yearDateRange: null,
      type: 'progress',
      companies: [],
      error: [],
      checked: ['客户公司', '部门', '推荐岗位', '姓名', '人选进展', '进展时间'],
      isIndeterminate: false,
      checkAll: false,
      pickerOptions: { shortcuts: [] },
      sortChecked: [],
      hrNames: [],
    }
  },
  watch: {
    checked: {
      handler: function(val, oldVal) {
        this.sortChecked = val
      },
      immediate: true,
    },
    type: {
      handler: function(val, oldVal) {
        if (val === 'progress' || this.sortable) return
        this.$nextTick(() => {
          const sortableEl = document.getElementById('sortList')
          const exchange = evt => {
            const arr = evt.to.children
            const result = []
            for (let i = 0, len = arr.length; i < len; i += 1) {
              result.push(arr[i].innerText)
            }
            this.sortChecked = result
          }
          this.sortable = Sortable.create(sortableEl, {
            onUpdate: function(evt) {
              exchange(evt)
            },
          })
        })
      },
      immediate: true,
    },
    companyName: {
      handler: async function(val, oldVal) {
        if (val) {
          const res = await app.service('project').getOldestProjectTime({ companyName: val })
          if (res.status === 'success') {
            this.setLastPickerOption(res.data)
          } else this.setLastPickerOption()
        } else this.setLastPickerOption()
      },
      immediate: true,
    },
  },
  created() {
    this.checkbox = [
      '客户公司',
      '部门',
      '推荐岗位',
      '姓名',
      '人选进展',
      '进展时间',
      '公司',
      '目前职位',
      '性别',
      '地域',
      // '离职意愿度',
      // '当前薪酬',
      // '工作经历',
      '简介',
      // '教育经历',
      '出生年月',
      '婚育',
      '职能模块',
      '细分职能',
      '擅长方向',
      '个性标签',
      '职级',
      '管理职级',
      '专业职级',
      '业绩',
      '学历',
      '行业',
      '规模',
      '管理基金数量',
      '任职期',
      '管理基金',
      '投资风格',
      // '口碑打分',
      '组别',
      '部门(人选)',
      '学历标签',
      '语言标签',
      '沟通日志',
      '曾任职公司',
      '本科院校',
      '硕士院校',
    ]
    this.pickerOptions = {
      shortcuts: [
        {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(new Date().getMonth() - 1)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(new Date().getMonth() - 3)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近半年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(new Date().getMonth() - 6)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(new Date().getMonth() - 12)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '今年以来',
          onClick(picker) {
            const end = new Date()
            const start = new Date(`${new Date().getFullYear()}-01-01`)
            picker.$emit('pick', [start, end])
          },
        },
      ],
    }
  },
  methods: {
    show(params) {
      this.companyName = ''
      this.dateRange = null
      this.yearDateRange = null
      this.type = 'progress'
      this.checked = ['客户公司', '部门', '推荐岗位', '姓名', '人选进展', '进展时间']
      this.checkAll = false
      this.isIndeterminate = false
      if (params && params.defaultCompanyName) {
        this.companyName = params.defaultCompanyName
        this.searchCompany(this.companyName)
      }
      if (params && params.defaultType) this.type = params.defaultType
      this.visible = true
    },
    setLastPickerOption(time) {
      const lastOption = this.pickerOptions.shortcuts[this.pickerOptions.shortcuts.length - 1]
      if (!lastOption) return
      const obj = time
        ? {
            text: '合作以来',
            onClick(picker) {
              const end = new Date()
              const start = new Date(time)
              picker.$emit('pick', [start, end])
            },
          }
        : {}
      if (time && lastOption.text === '合作以来') {
        this.pickerOptions.shortcuts.splice(this.pickerOptions.shortcuts.length - 1, 1, obj)
      } else if (time && lastOption.text !== '合作以来') {
        this.pickerOptions.shortcuts.push(obj)
      } else if (!time && lastOption.text === '合作以来') {
        this.pickerOptions.shortcuts.pop()
      }
    },
    async searchCompany(queryString) {
      if (!queryString) return (this.companies = [])
      try {
        const { status, data } = await window.app.service('company').serchCompany(queryString)
        if (status === 200) {
          this.companies = data.map(company => ({ 简称: company['简称'], _id: company._id }))
        }
      } catch (e) {
        this.companies = []
      }
    },
    chooseCompany(name) {
      const option = this.companies.find(a => a.简称 === name)
      const cid = option && option._id
      this.cid = cid
      this.getCompanyHrs(cid)
    },
    async getCompanyHrs(cid) {
      const res = await app.service('company').getCompanyHrsByCid(cid)
      if (res.status === 'success') {
        const hrs = res.data
        this.hrCid = cid
        this.getHrNames(hrs)
      } else this.$message.error(res.msg)
    },
    async getHrNames(hrs) {
      const res = await app.service('company').getCompanyHr(hrs)
      if (res.status === 'success') {
        const names = res.data.map(a => a.姓名)
        this.hrNames = [...new Set(names)]
      } else this.$message.error(res.msg)
    },
    async clientCompanyCount() {
      const loading = this.$loading({
        lock: true,
        text: '正在客户公司项目盘点，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').clientCompanyCount({
          companyName: this.companyName,
          dateRange: this.dateRange || [],
        })
        if (res && res.status === 'success' && res.data) {
          // const manager = this.project.项目经理
          //   ? Array.isArray(this.project.项目经理)
          //     ? this.project.项目经理.join(';')
          //     : this.project.项目经理
          //   : ''
          // const duijie = this.project.项目对接
          //   ? Array.isArray(this.project.项目对接)
          //     ? this.project.项目对接.join(';')
          //     : this.project.项目对接
          //   : ''
          const companyId = this.companies.filter(v => v.简称 === this.companyName)[0]._id
          app.root.$refs.ClientCompanyCountEditor.open({
            url: res.data.url,
            md5: res.data.md5,
            companyId,
            countResult: res.data.countResult,
            documentType: res.data.documentType,
            fileType: res.data.fileType,
            originalname: res.data.originalname,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成项目搜索进度报告出错`)
      }
      loading.close()
    },
    async commendatoryClientCompanyCount() {
      if (!this.yearDateRange) return this.$message.error('请确定要查询的年限')
      const loading = this.$loading({
        lock: true,
        text: '正在客户公司项目盘点，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').commendatoryClientCompanyCount({
          companyName: this.companyName,
          dateRange: this.yearDateRange,
        })
        if (res && res.status === 'success' && res.data) {
          this.visible = false
          app.root.$refs.CommendatoryClientCompanyCountEditor.open({
            url: res.data.url,
            md5: res.data.md5,
            countResult: res.data.countResult,
            documentType: res.data.documentType,
            fileType: res.data.fileType,
            originalname: res.data.fileType,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成项目搜索进度报告出错`)
      }
      loading.close()
    },
    async getCompanyProgressReport() {
      const loading = this.$loading({
        lock: true,
        text: '正在获取人选概况，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').getCompanyProgressReport({
          companyName: this.companyName,
          dateRange: this.dateRange || [],
        })
        if (res && res.status === 'success' && res.data) {
          app.root.$refs.WpsDialog.open({
            url: res.data.url,
            md5: res.data.md5,
            documentType: res.data.documentType,
            fileType: res.data.fileType,
            originalname: res.data.fileType,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成人选概况报告出错`)
      }
      loading.close()
    },
    async getCompanyRecomendNamelist() {
      const loading = this.$loading({
        lock: true,
        text: '正在获取人选详情报告，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').getCompanyRecomendNamelist({
          companyName: this.companyName,
          dateRange: this.dateRange || [],
          header: this.sortChecked,
        })
        if (res && res.status === 'success' && res.data) {
          app.root.$refs.WpsDialog.open({
            url: res.data.url,
            md5: res.data.md5,
            documentType: res.data.documentType,
            fileType: res.data.fileType,
            originalname: res.data.fileType,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成人选概况报告出错`)
      }
      loading.close()
    },
    async clientYearReport() {
      if (!this.companyName) return this.$message.error('请确定要查询的公司')
      const option = {
        公司: this.companyName,
      }
      const lastYear = new Date(`${new Date().getFullYear() - 1}`).getTime()
      const thisYear = new Date(`${new Date().getFullYear()}`).getTime()
      option.timeRange = [lastYear, thisYear]
      option.年份 = new Date(lastYear).getFullYear()
      const report = await this.checkYearReport(option)
      if (report) {
        app.root.$refs.ModifyClientYearReportDialog.open(report)
      } else {
        const newReport = await this.getClientYearReport(option)
        app.root.$refs.ModifyClientYearReportDialog.open(newReport)
      }
    },
    async getClientYearReport(option) {
      const res = await app.service('misc').getClientYearReport(option)
      if (res.status === 'success') {
        return res.data
      } else this.$message.error(res.msg)
    },
    async checkYearReport(option) {
      const res = await app.service('misc').findLatestClientYearReport(option)
      if (res && res.status === 'success' && res.data) {
        return res.data
      } else return null
    },
    onConfirm() {
      if (!this.companyName) {
        this.error[0] = true
        return
      }
      if (this.type === 'client-project-count') {
        this.visible = false
        this.clientCompanyCount()
      } else if (this.type === 'progress') {
        this.visible = false
        this.getCompanyProgressReport()
      } else if (this.type === 'commendatory-client-company-count') {
        this.commendatoryClientCompanyCount()
      } else if (this.type === 'client-year-report') {
        this.clientYearReport()
      } else {
        this.visible = false
        this.getCompanyRecomendNamelist()
        // const query = `?range=${JSON.stringify(this.dateRange)}&headers=${JSON.stringify(this.checked)}`
        // this.$router.push(`/company-${this.type}/${this.companyName}${query}`)
      }
    },
    handleCheckAllChange(val) {
      this.checked = val ? this.checkbox : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.data.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length
    },
  },
}
</script>

<style scoped>
.checkbox_item {
  width: 100px;
}
.headers_item {
  display: inline-block;
  background-color: rgb(255, 153, 0);
  padding: 5px;
  color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(255, 109, 0, 0.1);
}
</style>
